
import { mapGetters } from 'vuex'
import DobInput from '../parts/DobInput.vue'

export default {
    components: { DobInput },
    props: {
        // null = undecided, true/false = answered
        hasGuests: { type: Boolean, default: null },
        guests: { type: Array, default: () => [] },
        slug: { type: String, default: null },
        aep: { type: Boolean, default: false },
    },
    computed: {
        // clientRelationships ({ value: Relationship enum, text }) is the
        // Salesforce-synced store getter (SPOUSE/PARENT/CHILD/FRIEND/OTHER).
        // NOTE: the old GUEST_REL list had a 'SIBLING' option that is NOT in the
        // backend Relationship enum — it's intentionally gone now (use OTHER).
        ...mapGetters(['clientRelationships']),
    },
    methods: {
        setHas (v) {
            this.$emit('update-has', v)
            if (v && !this.guests.length) {
                this.$emit('add-guest')
            } else if (!v) {
                this.$emit('clear-guests')
            }
        },
        addGuest () { this.$emit('add-guest') },
        removeGuest (i) { this.$emit('remove-guest', i) },
        setGuestReturning (g, v) {
            g.returning = v
            g.lookupFound = false
            g.lookupError = ''
        },
        canGuestLookup (g) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(g.lookupEmail || '') &&
                g.lookupDobM && g.lookupDobD && String(g.lookupDobY || '').length === 4
        },
        // Whether to ask for name + relationship manually. We only need them when
        // we CAN'T pull them from an existing record: a caretaker (no guidance) or
        // a brand-new guidance guest. A returning guidance guest's details come
        // from their looked-up record, so we hide the fields for them.
        showIdentity (g) {
            return g.needsGuidance === false ||
                (g.needsGuidance === true && g.returning === false)
        },
        // Same masking AboutDemographicBlock applies — (xxx) xxx-xxxx.
        formatGuestPhone (g, e) {
            const d = String(e.target.value || '').replace(/\D/g, '').slice(0, 10)
            let v = d
            if (d.length >= 4 && d.length < 7) v = `(${d.slice(0, 3)}) ${d.slice(3)}`
            else if (d.length >= 7) v = `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
            g.phone = v
        },
        async guestLookup (g) {
            // NOTE (Vue 2 reactivity): every g.xxx we mutate here MUST be a key
            // declared in newGuest() (StepByStepV2.vue). Assigning a brand-new key
            // to a guest object is non-reactive and the UI won't update until an
            // unrelated declared key changes — that was the "lookup error only
            // appears after editing the DOB" bug. New flag? Add it to newGuest().
            g.lookupError = ''
            g.lookupLoading = true
            try {
                const dob = `${g.lookupDobY}-${String(g.lookupDobM).padStart(2, '0')}-${String(g.lookupDobD).padStart(2, '0')}`
                const resp = await this.$api.getExistingClientToken({
                    email: g.lookupEmail,
                    dob,
                    slug: this.slug || undefined,
                    aep: this.aep,
                })
                if (resp?.error || resp?.detail) {
                    const e = resp.error || resp.detail
                    g.lookupError = typeof e === 'string' ? e : (e?.message || 'We couldn’t find an account for this guest.')
                    return
                }
                g.token = resp.token
                g.first = g.first || resp.first_name || ''
                g.last = g.last || resp.last_name || ''
                g.email = resp.email || g.lookupEmail
                g.dob = dob
                g.zip_code = resp.zip_code
                g.fips = resp.fips
                g.effective_date = resp.effective_date
                g.soa60days = resp.soa60days
                g.hasPhoneOnFile = !!resp.has_phone
                g.lookupFound = true
            } catch (err) {
                g.lookupError = err?.message || 'We couldn’t find that account.'
            } finally {
                g.lookupLoading = false
            }
        },
    },
}
